<template>
  <a-config-provider :locale="antdLanguage">
    <router-view />
  </a-config-provider>
</template>

<script setup lang="ts">
import useLocale from '@/hooks/useLocale'
const { antdLanguage } = useLocale()
</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
#app {
  display: flex;
  position: relative;
  flex-direction: column;
  // min-height: 100vh;
  height: 100svh;
  color: #333333;
}
</style>
